module.exports = __webpack_public_path__ + "static/media/4_Connect-Wires.564066c5.svg";